/**
 * @fileoverview Alert strip for expiring contracts warnings
 * @module TechStackAnalysis/components/AlertStrip
 */

import React from 'react';
import { AlertTriangle, ArrowRight } from 'lucide-react';

/**
 * Alert strip component showing contract expiration warnings
 * @param {Object} props
 * @param {Array} props.alerts - Array of alert objects
 * @param {Function} props.onActionClick - Handler for action button click
 */
const AlertStrip = ({ alerts, onActionClick }) => {
  if (!alerts || alerts.length === 0) return null;

  return (
    <>
      {alerts.map((alert, index) => (
        <div
          key={index}
          className={`ts-alert-strip ${alert.type === 'critical' ? 'ts-alert-critical' : 'ts-alert-warning'}`}
        >
          <div className="ts-alert-icon">
            <AlertTriangle size={20} />
          </div>
          <div className="ts-alert-content">
            <p className="ts-alert-message">{alert.message}</p>
            {alert.vendors && alert.vendors.length > 0 && (
              <p className="ts-alert-vendors">
                {alert.vendors.slice(0, 3).join(', ')}
                {alert.vendors.length > 3 && ` +${alert.vendors.length - 3} more`}
              </p>
            )}
          </div>
          {alert.actionUrl && (
            <button
              className="ts-alert-action"
              onClick={() => onActionClick?.(alert.actionUrl)}
            >
              Review <ArrowRight size={14} />
            </button>
          )}
        </div>
      ))}
    </>
  );
};

export default AlertStrip;
